import { InjectionToken } from '@angular/core';
import { IFrameEventHandler } from './presentation/models/frame-event-handler.interface';
import { IUserMenuItem } from './presentation/models/user-menu-item.interface';

/**
 * A `DI token` that can be used for providing a user menu item. These will be registerd by the `SharedModule` during application startup.
 * ### Usage example
 *
 * In your `NgModule` declaration:
 * ```
 *  providers: [
 *      { provide: USER_MENU_ITEMS, useValue: myUserMenuItem, multi: true }
 *  ]
 * ```
 * Provide your user menu item:
 * ```
 *  export const myUserMenuItem: IUserMenuItem = {
 *    key: '...',
 *    order: ...,
 *    description: '...,
 *    icon: '...',
 *    onClick: () => ...
 *    ...
 *  }
 * ```
 */
export const USER_MENU_ITEMS = new InjectionToken<IUserMenuItem>('User menu items');

/**
 * A `DI token` to register handler(s) for event-based iFrame communication between the main window and any embedded iFrame
 */
export const FRAME_EVENT_HANDLERS = new InjectionToken<Array<IFrameEventHandler> | IFrameEventHandler>('Frame event handlers');
